var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pulse-loader',{staticClass:"w-100 text-center loader",attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }